/**
 * @name: goods
 * @description:
 * @author: qq2575896094
 * @time: 2024/3/22
 */

const prefix = '/onlinecs/manage/goods'

/**
 * 商品列表
 * @type {string}
 */
export const getGoodsList = `${prefix}/queryGoodsList`

/**
 * 商品详情
 * @type {string}
 */
export const getGoodsDetail = '/onlinecs/service/goods/detail'

/**
 * 商品品类
 * @type {string}
 */
export const getCategoryListUrl = `${prefix}/queryGoodsCategoryGroupList`

/**
 * 商品细类
 * @type {string}
 */
export const getInfiniteList = `${prefix}/queryInfiniteCategoryList`
